/* Hamakija — favourites page: renders the products saved with the heart (localStorage "hk-favs"). */
(() => {
  if (customElements.get('hk-wishlist')) return;
  const read = () => (window.HkFavs ? window.HkFavs.read() : []);
  const write = (v) => window.HkFavs && window.HkFavs.write(v);

  class HkWishlist extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-hk-wl-grid]');
      this.empty = this.querySelector('[data-hk-wl-empty]');
      this.loading = this.querySelector('[data-hk-wl-loading]');
      this.count = this.querySelector('[data-hk-wl-count]');
      this.clearBtn = (this.closest('.hk-section') || document).querySelector('[data-hk-wl-clear]');
      this.root = this.dataset.root || '';

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', () => {
          write([]);
          this.grid.innerHTML = '';
          document.dispatchEvent(new CustomEvent('hk:favs', { detail: { favs: [] } }));
          this.update();
        });
      }
      // heart clicked off on this page → remove the card
      document.addEventListener('hk:favs', (e) => {
        const d = e.detail || {};
        if (!d.handle || d.on !== false) return;
        const item = this.grid.querySelector(`[data-hk-wl-item="${CSS.escape(d.handle)}"]`);
        if (item) item.remove();
        this.update();
      });
      this.load();
    }

    async load() {
      const handles = read();
      if (!handles.length) { this.update(); return; }
      this.loading.hidden = false;
      const results = await Promise.all(handles.map((h) =>
        fetch(`${this.root}/products/${encodeURIComponent(h)}?section_id=${this.dataset.section}`)
          .then((r) => ({ h, status: r.status, html: r.ok ? r.text() : null }))
          .catch(() => ({ h, status: 0, html: null }))));
      const gone = [];
      for (const r of results) {
        if (r.status === 404) { gone.push(r.h); continue; }
        const html = r.html ? await r.html : null;
        if (!html) continue;
        const card = new DOMParser().parseFromString(html, 'text/html').querySelector('.hk-pcard');
        if (!card) continue;
        const item = document.createElement('div');
        item.className = 'hk-wl__item';
        item.dataset.hkWlItem = r.h;
        item.appendChild(document.adoptNode(card));
        this.grid.appendChild(item);
      }
      // products deleted from the store disappear from the list
      if (gone.length) write(read().filter((h) => !gone.includes(h)));
      this.loading.hidden = true;
      if (window.HkFavs) window.HkFavs.sync();
      this.update();
    }

    update() {
      const n = this.grid.children.length;
      this.empty.hidden = n > 0;
      if (this.clearBtn) this.clearBtn.hidden = n === 0;
      if (this.count) {
        this.count.hidden = n === 0;
        const few = n % 10 >= 2 && n % 10 <= 4 && !(n % 100 >= 12 && n % 100 <= 14); // Polish plural rule
        const tpl = n === 1 ? this.dataset.one : (few ? this.dataset.few : this.dataset.many);
        this.count.textContent = (tpl || '[n]').replace('[n]', n);
      }
    }
  }
  customElements.define('hk-wishlist', HkWishlist);
})();
